import { render, staticRenderFns } from "./participants-container.vue?vue&type=template&id=2f87bd58"
import script from "./participants-container.vue?vue&type=script&lang=js"
export * from "./participants-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports